import { Pipe, PipeTransform } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { extractNationalPart } from "../utils/phone.utils";

@Pipe({ name: 'highlight' })
export class HightlightPipe implements PipeTransform {

  constructor(private domSanitizer: DomSanitizer){}

  public transform(value: string, search: string, countryPhoneCode?: string) {
    if (!value) return '';
    if (!search) return value;
    const safeValue = value
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
    const escapeRegex = (str: string) => str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

    // For E.164 searches always highlight by the national part so that all occurrences
    // in the number are matched, regardless of whether a country code prefix is stored.
    if (search.startsWith('+')) {
      const nationalPart = extractNationalPart(search, countryPhoneCode);
      if (nationalPart) {
        const escapedNational = escapeRegex(nationalPart);
        const result = safeValue.replace(new RegExp(`(${escapedNational})`, 'gi'), '<b>$1</b>');
        if (result !== safeValue) {
          return this.domSanitizer.bypassSecurityTrustHtml(result);
        }
      }
    }

    // Default exact match (names, or numbers already stored in matching format).
    const escaped = escapeRegex(search);
    const result = safeValue.replace(new RegExp(`(${escaped})`, 'gi'), '<b>$1</b>');
    return this.domSanitizer.bypassSecurityTrustHtml(result);
  }
}
